<template>
  <div>
    <section-title id="telepointages">
      {{ sectionTitle }}
    </section-title>
    <div style="position: relative;">
      <div v-if="table.items.length && !error">
        <b-table
          id="telepointages-table"
          :class="{ 'blur-area': loading }"
          sticky-header
          :items="
            table.items.slice((currentPage - 1) * 10, currentPage * perPage)
          "
          :fields="table.fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
        ></b-table>

        <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="table.items.length"
          :per-page="perPage"
          aria-controls="telepointages-table"
        ></b-pagination>
      </div>
      <b-card v-if="loading" class="center">
        <b-media class="text-center">
          <spinner></spinner>
        </b-media>
      </b-card>
      <b-card v-if="!table.items.length">
        <b-media>
          {{ $t("telepointages-no-data") }}
        </b-media>
      </b-card>
      <b-card v-if="error">
        <b-media>
          {{ $t("telepointages-error") }}
        </b-media>
      </b-card>
    </div>
  </div>
</template>

<script>
import SectionTitle from "../../SectionTitle.vue";
import axiosVita from "../../../axiosVita";
import Spinner from "../../Helpers/Spinner/Spinner.vue";

var moment = require("moment");

export default {
  name: "Telepointages",
  components: {
    SectionTitle,
    Spinner
  },
  props: ["sectionTitle"],
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      sortBy: "row_number",
      sortDesc: false,
      table: {
        fields: [
          { label: "#", key: "row_number", sortable: true },
          {
            label: "Nom de l'intervenant",
            key: "adv_fullname",
            sortable: true
          },
          {
            label: "Date de pointage",
            key: "pointage_datetime",
            sortable: true
          },
          { label: "Outil de pointage", key: "pointage_tool", sortable: true },
          { label: "Type de pointage", key: "pointage_type", sortable: true }
        ],
        items: [
          {
            isActive: true,
            pointage_datetime: "Chargement...",
            adv_fullname: "Chargement...",
            pointage_tool: "Chargement..."
          },
          {
            isActive: false,
            pointage_datetime: "Chargement...",
            adv_fullname: "Chargement...",
            pointage_tool: "Chargement..."
          },
          {
            isActive: false,
            pointage_datetime: "Chargement...",
            adv_fullname: "Chargement...",
            pointage_tool: "Chargement..."
          },
          {
            isActive: true,
            pointage_datetime: "Chargement...",
            adv_fullname: "Chargement...",
            pointage_tool: "Chargement..."
          }
        ]
      },
      loading: true,
      error: false
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      let vue = this;

      axiosVita
        .post("api/TelegestionEspaceClient/PostTelepointages", {
          offset: 1
        })
        .then(function(response) {
          vue.table.items = [];

          response.data.telepointages.forEach(function(element) {
            var row = {
              row_number: element.rowNumber,
              isActive: false,
              pointage_datetime: moment(element.pointageDatetime).format(
                "DD/MM/YYYY HH[h]mm"
              ),
              adv_fullname: element.advFullname,
              pointage_tool: element.pointageTool
                ? "Vitaphone"
                : "Application Mobile",
              pointage_type: element.pointageType == 1 ? "Arrivée" : "Départ"
            };

            vue.table.items.push(row);
          });
        })
        .catch(function(error) {
          console.log(error);
          vue.error = true;
        })
        .finally(function() {
          vue.loading = false;
        });
    }
  }
};
</script>

<style>
.blur-area {
  filter: blur(4px);
}
.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
